import React from 'react';
import { Link } from 'react-router-dom';
import { Bubble, LoaderButton } from 'ctia-ui';
import PropTypes from 'prop-types';

const DecisionResultPage = ({ id, isAccepted }) => {
  const resultTitle = isAccepted ? 'accepted' : 'rejected';
  const renderReportsLink = () => {
    if (!isAccepted) return null;
    return (
      <Link to={`/lab/results/${id}`} style={{ marginLeft: 20 }}>
        <LoaderButton bsStyle="info" text="Upload Reports &rarr;" />
      </Link>
    );
  };

  return (
    <div>
      <Bubble>Request has been {resultTitle} successfully.</Bubble>
      <Link to="/lab/requests">
        <LoaderButton text="Done" />
      </Link>
      {renderReportsLink()}
    </div>
  );
};

DecisionResultPage.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isAccepted: PropTypes.bool
};

DecisionResultPage.defaultProps = {
  isAccepted: false,
  id: 1
};

export default DecisionResultPage;



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Laboratory/DecisionResultPage.js